import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { TooltipService } from '../../../services/tooltip-service';
import { emptyObject } from 'ui-components/default-props/empty';

import less from './popover-content.module.css';

export const PopoverContent = React.forwardRef(
  ({ children, style = emptyObject, arrowClass = 'down', position = 'top', isDark = false }, ref) => {
    return (
      <div ref={ref} className={classnames(less.tooltip, less[position])} style={style}>
        {children}
        <div
          className={classnames(less['tooltip-arrow'], less[arrowClass], {
            [less.dark]: isDark,
          })}
        />
      </div>
    );
  },
);

PopoverContent.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  arrowClass: PropTypes.oneOf(['down', 'right', 'up', 'left']),
  position: PropTypes.oneOf(TooltipService.getValidPositions()),
  isDark: PropTypes.bool,
};
